import { render } from "./LoanSchedules.vue?vue&type=template&id=05fe5ebd&scoped=true"
import script from "./LoanSchedules.vue?vue&type=script&lang=js"
export * from "./LoanSchedules.vue?vue&type=script&lang=js"

import "./LoanSchedules.vue?vue&type=style&index=0&id=05fe5ebd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fe5ebd"]])

export default __exports__